const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/priority-frameworks.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/idea-management/priority-frameworks')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {}
});